// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"x6-z","displaySixCardTiles":"y6-z"};